import React from 'react';

const FilterTabs = ({ value, onChange, options, className = '' }) => (
  <div className={`inline-flex items-center bg-neutral-100 border border-neutral-200 rounded-lg p-1 gap-0.5 ${className}`}>
    {options.map((opt) => {
      const isObj = typeof opt === 'object';
      const val = isObj ? opt.value : opt;
      const label = isObj ? opt.label : opt;
      const count = isObj ? opt.count : undefined;
      const active = value === val;
      return (
        <button
          key={val}
          type="button"
          onClick={() => onChange(val)}
          className={`
            px-3 py-1.5 rounded-md text-sm font-medium capitalize transition-all
            ${active
              ? 'bg-white text-neutral-900 shadow-sm'
              : 'text-neutral-600 hover:text-neutral-900'}
          `}
        >
          {label}
          {count !== undefined && (
            <span className={`ml-1.5 text-xs ${active ? 'text-neutral-500' : 'text-neutral-400'}`}>
              {count}
            </span>
          )}
        </button>
      );
    })}
  </div>
);

export default FilterTabs;
